<!--
@author liyiquan
@date 2021-12-17
@params
-->

<template>
  <div :style="{'height': this.height}" v-if="imgSrc" ref="elImageCustom">
    <image-viewer
      :z-index="zIndex"
      :initial-index="imageIndex"
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="imgList"
    />
    <el-image
      :style="{ ...style, cursor: 'pointer' }"
      :src="ossImg(imgSrc, imgWidth, imgHeight, updated)"
      :fit="fit"
      :lazy="!!lazy || lazy === ''"
      @click="
        clickMe(imgSrc);
        $emit('click');
      "
      :alt="alt"
      :scroll-container="(!!lazy || lazy === '') && scrollContainer"
    >
      <div slot="error" class="image-slot" :style="{lineHeight: imgHeight + 'px', fontSize: imgHeight/4 + 'px'}">
        <i class="el-icon-picture-outline"></i>
      </div>
      <div slot="placeholder" class="image-slot" :style="{lineHeight: imgHeight + 'px'}">
        <i class="el-icon-loading"></i>
      </div>
    </el-image>
  </div>
  <div
    v-else
    class="el-image"
    :key="key"
    :style="style"
    @click="$emit('click')"
  >
    <div class="image-slot" :style="{lineHeight: imgHeight + 'px', fontSize: imgHeight/4 + 'px'}">
      <i class="el-icon-picture-outline"></i>
    </div>
  </div>
</template>

<script>
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue";
export default {
  data() {
    return {
      imgSrc: "",
      imgList: [],
      imgWidth: undefined,
      imgHeight: undefined,
      showViewer: false,
      imageIndex: 0,
    };
  },
  components: {
    ImageViewer,
  },
  props: {
    // 图片地址(列表)
    src: Array | String | "",
    // alt
    alt: String | '',
    // 是否可大图预览
    preview: Boolean | undefined,
    // 更新时间
    updated: String | Number,
    // 是否启用懒加载
    lazy: Boolean | undefined,
    // 懒加载滚动容器
    scrollContainer: String | undefined,
    index: Number | 0,
    fit: "fill" | "contain" | "cover" | "none" | "scale-down",
    width: Number | 0,
    height: Number | 0,
    border: Boolean | true,
  },
  mounted() {
    if (!this.imgWidth && !this.imgHeight) {
      const borderSize = this.border === false? 0: 2;
      if (this.width || this.height) {
        this.imgWidth = parseInt(this.width) - borderSize;
        this.imgHeight = parseInt(this.height) - borderSize;
        return;
      }

      const elm = this.$refs.elImageCustom;
      if (elm !== undefined) {
        const elmRef = elm.$el;
        let w = elmRef.offsetWidth,
          h = elmRef.offsetHeight;

        // 不可见，使用 style
        if (w === 0 && h === 0) {
          w = (elmRef.style.width && parseInt(elmRef.style.width)) || 0;
          h = (elmRef.style.height && parseInt(elmRef.style.height)) || 0;
        }

        this.imgWidth = parseInt(w) - borderSize;
        this.imgHeight = parseInt(h) - borderSize;
      }
    }
  },
  watch: {
    src: {
      handler(newVal) {
        if (newVal) {
          let url, list;
          if (newVal instanceof Array) {
            url = newVal[this.index || 0];
            list = newVal;
          } else {
            url = newVal;
            list = [newVal];
          }

          this.imgSrc = url;
          this.imgList = list;
        } else {
          this.imgSrc = "";
          this.imgList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    clickMe(img) {
      if (!!this.preview || this.preview === "") {
        this.imageIndex = Math.max(0, this.imgList.indexOf(img));
        this.showViewer = true;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>
<style lang="scss">
</style>